import { withI18n } from '../../../contexts/i18n';

import type { I18nService } from '@shared/types/i18n';

type Props = {
  i18n: I18nService;
  price: number;
};

const FormattedCurrency = ({ i18n, price }: Props) => (
  <>{i18n.formatCurrency(price)}</>
);

export default withI18n(FormattedCurrency);
